import {
	buildLocalizedSeoLinks,
	getLocalizedSeoUrls,
	ogImageUrl,
	ogSlugForPath,
} from "@/lib/seo";

export function buildPageHead({
	matches,
	internalPath,
	title,
	description,
	ogImage,
	ogType = "website",
}: {
	matches: unknown;
	internalPath: string;
	title: string;
	description: string;
	ogImage?: string;
	ogType?: "website" | "article";
}) {
	const seoUrls = getLocalizedSeoUrls({ matches, internalPath });
	const image = ogImageUrl(ogImage ?? ogSlugForPath(internalPath));
	const pageTitle = formatSeoTitle(title);

	return {
		meta: [
			{ title: pageTitle },
			{ name: "description", content: description },
			{ property: "og:title", content: pageTitle },
			{ property: "og:description", content: description },
			{ property: "og:image", content: image },
			{ property: "og:url", content: seoUrls.canonicalUrl },
			{ property: "og:type", content: ogType },
			{ name: "twitter:card", content: "summary_large_image" },
			{ name: "twitter:title", content: pageTitle },
			{ name: "twitter:description", content: description },
			{ name: "twitter:image", content: image },
		],
		links: buildLocalizedSeoLinks({ matches, internalPath }),
	};
}

export function formatSeoTitle(title: string) {
	const cleaned = title
		.trim()
		.replace(/^AgentReacher\s*\|\s*/i, "")
		.replace(/\s+-\s+AgentReacher(?:\s+Help)?(?:\s+\|\s+.*)?$/i, "")
		.replace(/\s+\|\s+AgentReacher$/i, "")
		.replace(/^AgentReacher\s+for\s+/i, "For ");

	return cleaned ? `AgentReacher | ${cleaned}` : "AgentReacher";
}
